import { VisitStatus } from "@visitproof/types";

export const colorForStatus = (status: VisitStatus): string => {
  switch (status) { 
    case "scheduled": 
      return "#4caf50";
    case "supervisor_started": 
      return "#2196f3";
    case "supervisor_arrived": 
      return "#4caf50";
    case "supervisor_enroute": 
      return "#ff9800";
    case "no_show": 
      return "#f44336";
    case "supervisor_ended": 
      return "#9c27b0";
    case "pending":
      return "#ffc107";
    default: 
      return "#9e9e9e";
  }
};

export const getStatusLabel = (status: VisitStatus): string => {
  switch (status) {
    case "scheduled": 
      return "Scheduled";
    case "supervisor_started": 
      return "Supervisor Started";
    case "supervisor_arrived": 
      return "Supervisor Arrived";
    case "supervisor_enroute": 
      return "Supervisor En Route";
    case "supervisor_no_show": 
      return "Supervisor No Show";
    case "supervisor_ended": 
      return "Supervisor Ended";
    case "pending":
      return "Pending";
    case "completed":
      return "Completed";
    default: 
      return "Unknown";
  }
}; 